import { useMemo } from "react";

import Timestamp from "components/Timestamp";
import { makeTimestampToCopy } from "ds/components/Table/helpers";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { StackTaskRun } from "views/Stack/Tasks/gql";

import { STACK_TASKS_COLUMN_ID } from "../constants";
import useCellCopyAction from "../useCellCopyAction";

const StackTasksTableStartedAtCell = ({
  item: task,
  ...cellProps
}: TableSimpleCellProps<StackTaskRun>) => {
  const copyAction = useCellCopyAction({
    column: STACK_TASKS_COLUMN_ID.STARTED_AT,
    text: makeTimestampToCopy(task.createdAt),
  });

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <Timestamp timestamp={task.createdAt} variant="p-body3" />
    </TableSimpleCell>
  );
};

export default StackTasksTableStartedAtCell;
